import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmailSentimentBehindNumbers from "./EmailSentimentBehindNumbers";
import FauxTable from "../../components/FauxTable";
import Timestamp from "../../components/Timestamp";
import SentimentReport from "./SentimentReport";
import SentimentChart from "./SentimentChart";
import AuthorizedUserContext from "../../utils/AuthorizedUserContext";

import {
	withStyles,
	withTheme,
	withWidth,
	Typography
} from '@material-ui/core';

const minHeight = 625;
const styles = theme => ({
	root: {
		minHeight: minHeight,

		/*[theme.breakpoints.down('xs')]: {
			minHeight: 625
		}*/
	},

	tab: {
		fontWeight: 200
	},

	tabLabelContainer: {
		paddingLeft: theme.spacing(.75),
		paddingRight: theme.spacing(.75)
	},

	selectedTab: {
		fontWeight: 500
	},

	detailedReportGrid: {
		height: minHeight,
		overflow: "hidden"
	},

	emailTable: {
		height: 400,
		overflow: "scroll",
		marginTop: theme.spacing(2),
		borderRadius: theme.spacing(0.5),
		border: `1px solid ${theme.palette.grey[300]}`
	}
});

class EmailSentimentReportItem extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			distressEmails: null
		};
		this.pointClicked = this.pointClicked.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
			this.setState({distressEmails: null});
		}
	}

	pointClicked(sentimentId) {
		let item,
			{data} = this.props;

		if (data && data.sentiment) {
			item = data.sentiment.find(sent => sent.sentimentId === sentimentId);
			if (item && item.distressEmails && item.distressEmails.length) {
				item.distressEmails.sort((a, b) => b.score - a.score);
				this.setState({distressEmails: item.distressEmails});
			}
		}
	}

	render() {
		let {distressEmails} = this.state,
			{classes, theme, fidoError, width, data, previousDays, useMoreInfoDialog, reportTitle} = this.props,
			columns = [{
				id: "from",
				label: "Author",
				formatter: data => data
			}, {
				id: "content",
				label: width.includes("xs") ? "Content" : "Email Content",
				formatter: (data, all) => {
					return (
						<React.Fragment>
							<Timestamp time={all.created_at} reducedSize={false} format={`${width.includes("xs") ? "M/D/YY h:mma" : "MMM Do @ h:mma"}`} />
							{all.subject ?
								<Typography>
									<b>Subject:</b> {all.subject}
								</Typography> : null
							}
							{data || all.content ?
								<Typography>
									<b>Content:</b> {data || all.content}
								</Typography> : null
							}
						</React.Fragment>
					);
				}
			}],
			columnSizing = [
				{xs: 3, sm: 3, md: 4, lg: 4, xl: 4},
				{xs: 9, sm: 9, md: 8, lg: 8, xl: 8}
			];

		return (
			<AuthorizedUserContext.Consumer>
				{authenticatedUser => {
					if (data && data.sentiment && authenticatedUser.ghosting) {
						data.sentiment.forEach(item => {
							if (item.distressEmails && item.distressEmails.length) {
								item.distressEmails.forEach(email => {
									email.from = "Anonymized";
								});
							}
						});
					}

					return (
						<SentimentReport
							fullWidth
							onlyCallout="Distress"
							fidoError={fidoError}
							nthXAxisDenomonator={90}
							previousDays={previousDays}
							reportTitle={reportTitle || "Email Sentiment"}
							clickPointHandler={this.pointClicked}
							useMoreInfoDialog={useMoreInfoDialog}
							moreInfoComponent={useMoreInfoDialog ? <EmailSentimentBehindNumbers /> : null}
							seriesConfig={[{
								name: "Happiness",
								type: "spline",
								color: theme.palette.secondary.blue
							},{
								name: "Distress",
								type: "spline",
								color: theme.palette.secondary.orange
							}]}
							dataConfig={[
								{
									data: data && data.sentiment,
									key: "period",
									valueKey: "happScore",
									asObject: ["clusterName", "linkTitle", "linkUrl"]
								},
								{
									data: data && data.sentiment,
									key: "period",
									valueKey: "distressScore",
									asObject: ["clusterName", "linkTitle", "linkUrl", "sentimentId"]
								}
							]}
							render={(chartInfo) => {
								let {chartConfig, clusterName, linkTitle, linkUrl} = chartInfo;
								return (
									<React.Fragment>
										<SentimentChart
											linkUrl={linkUrl}
											linkTitle={linkTitle}
											chartConfig={chartConfig}
											clusterName={clusterName}
											clickPointText="Click a point on the chart to see distress words and emails..." />
										{distressEmails && distressEmails.length ?
											<div className={classes.emailTable}>
												<FauxTable
													fidoError={fidoError}
													infiniteScroll={false}
													elevation={0}
													data={distressEmails}
													columns={columns}
													columnSizing={columnSizing}
													noResultsStyle={{paddingTop: "10%"}} />
											</div> : null
										}
									</React.Fragment>
								);
							}} />
					);
				}}
			</AuthorizedUserContext.Consumer>
		);
	}
}

EmailSentimentReportItem.defaultProps = {
	useMoreInfoDialog: true
};

EmailSentimentReportItem.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	width: PropTypes.any.isRequired,
	fidoError: PropTypes.bool,
	data: PropTypes.object,
	reportTitle: PropTypes.string,
	previousDays: PropTypes.number.isRequired,
	useMoreInfoDialog: PropTypes.bool
};

export default withStyles(styles)(withWidth()(withTheme(EmailSentimentReportItem)));
